<template>
  <svg width="16" height="16" fill="currentColor">
    <path
      d="M13.69 9.6089 8.7953 4.7712a1.141 1.141 0 0 0-1.6201 0L2.3375 9.609a1.1409 1.1409 0 0 0 0 1.6202 1.141 1.141 0 0 0 1.6087 0l4.039-4.039 4.039 4.039a1.141 1.141 0 0 0 .7987.3308 1.1404 1.1404 0 0 0 .8101-.3308 1.143 1.143 0 0 0 .3663-.7982 1.1406 1.1406 0 0 0-.3093-.822Z"
      fill="currentColor"
    />
  </svg>
</template>
